import sum from 'lodash/sum';
import { useCallback, useEffect, useState } from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { inputBaseClasses } from '@mui/material/InputBase';
import InputAdornment from '@mui/material/InputAdornment';
// utils
import { fCurrency } from 'src/utils/format-number';
// _mock
import { _roles, availability, INVOICE_SERVICE_OPTIONS, JOB_SKILL_OPTIONS, locationTypes } from 'src/_mock';

// components
import Iconify from 'src/components/iconify';
import { RHFAutocomplete, RHFSelect, RHFTextField } from 'src/components/hook-form';
import { Checkbox, Chip, FormControl, InputLabel, OutlinedInput, Select } from '@mui/material';
import { useData } from 'src/contexts/gantt-chart/gantt-context';

// ----------------------------------------------------------------------

export default function CreateEditEquipment() {
  const { control, setValue, watch, resetField ,getValues} = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'category',
  });

  const values = watch();

  const {dateWiseEquipments,completeData } = useData();
const [metrialCodeArray,setMetrialCodeArray]=useState([])
const [isDisabledLocation,setIsDisabledLocation]=useState(true)
  const handleAdd = (categoryIndex) => {
    const categories = watch('category') || [];
  
    if (!categories[categoryIndex]) return;
  
    const newItem = {
      code: '',
      description: '',
      quantity: '',
      unit: '',
      type: '',
      availablity: '',
      locationType: '',
      location: '',
    };
  
    const updatedCategories = categories.map((category, index) =>
      index === categoryIndex
        ? { ...category, items: [...(category.items || []), newItem] }
        : category 
    );
  
    setValue('category', updatedCategories, { shouldValidate: true });
  };
  
  const handleRemove = (categoryIndex, itemIndex) => {
    const categories = watch('category') || [];
  
    if (!categories[categoryIndex] || !categories[categoryIndex].items) return;
  
    const updatedCategories = categories.map((category, index) =>
      index === categoryIndex
        ? { ...category, items: category.items.filter((_, i) => i !== itemIndex) } 
        : category 
    );
  
    setValue('category', updatedCategories, { shouldValidate: true });
  };
  
  const handleAddMain = () => {
    append(       {
      category_name: '',
      items: [
        {
          code: '',
          description: '',
          quantity: '',
          unit: '',
          type: '',
          availablity: '',
          locationType: '',
          location: '',
        },
      ],
    },);
  };

  const handleRemoveMain = (index) => {
    remove(index);
  };


  const getMetrialCOdeArray=(value)=>{
    let filterSelectedItem=dateWiseEquipments?.equipment_categories?.find((item)=>item.id===value)
    if(filterSelectedItem?.equipments && filterSelectedItem.equipments.length>0){
      return filterSelectedItem.equipments
    }else{
      return []
    }
  }


  return (
    <Box sx={{ pt: 3 }}>
      <Stack divider={<Divider flexItem sx={{ borderStyle: 'dashed' }} />} spacing={3}>
        {fields.map((mainItem, mainIndex) => (
          <>
                <Box display="flex" gap="30px">
           <RHFSelect
                name={`category[${mainIndex}].category_name`}
                size="small"
                label="Equipment Category"
                InputLabelProps={{ shrink: true }}
                sx={{ maxWidth: { md: 300 } }}
                onChange={(e)=>{
                  setValue(`category[${mainIndex}].category_name`,e.target.value)
                }}
              >
                {dateWiseEquipments?.equipment_categories?.map((service) => (
                  <MenuItem key={service.id} value={service.id}>
                    {service.name}
                  </MenuItem>
                ))}
              </RHFSelect>
              { fields.length - 1 == mainIndex && (
                <Button
                  size="small"
                  color="primary"
                  startIcon={<Iconify icon="mingcute:add-line" />}
                  onClick={handleAddMain}
                  sx={{ flexShrink: 0 }}
                >
                  Add Item
                </Button>
              )}
              <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemoveMain(mainIndex)}
              >
                Remove
              </Button>
            </Box>
              <Divider sx={{marginBottom:"10px"}}/>
         { mainItem.items.map((item,index)=>(
            <Stack key={item.id}  spacing={1.5}>
            <Stack 
                    gap={3}
                    display="grid"
                    gridTemplateColumns={{
                      md: 'repeat(3, 1fr)',
                      lg: 'repeat(5, 1fr)',
                    }}
            >
       

              <RHFSelect
                name={`category[${mainIndex}].items[${index}].code`}
                size="small"
                label="Equipment Code"
                InputLabelProps={{ shrink: true }}
                onChange={(e)=>{
                  let filterSelectedItem=getMetrialCOdeArray(getValues().category[mainIndex]?.category_name)?.find((item)=>item.id===e.target.value)
                  setValue(`category[${mainIndex}].items[${index}].code`,e.target.value)
                  setValue(`category[${mainIndex}].items[${index}].description`,filterSelectedItem?.name)
                  setValue(`category[${mainIndex}].items[${index}].unit`,filterSelectedItem?.unit)
                  setValue(`category[${mainIndex}].items[${index}].type`,filterSelectedItem?.type)
                }}
              >
                {getMetrialCOdeArray(getValues().category[mainIndex]?.category_name)?.map((service) => (
                  <MenuItem key={service.id} value={service.id}>
                    {service.equipment_code}
                  </MenuItem>
                ))}
              </RHFSelect>
              <RHFTextField
                disabled
                size="small"
                name={`category[${mainIndex}].items[${index}].description`}
                label="Equipment Description"
                placeholder=""
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                disabled
                size="small"
                name={`category[${mainIndex}].items[${index}].unit`}
                label="Unit"
                placeholder="0"
                InputLabelProps={{ shrink: true }}
                // sx={{ maxWidth: { md: 116 } }}
              />
              <RHFTextField
                type="number"
                size="small"
                name={`category[${mainIndex}].items[${index}].unitPrice`}
                label="Unit Price"
                placeholder=""
                InputLabelProps={{ shrink: true }}
                   onChange={(e)=>{
                 setValue(`category[${mainIndex}].items[${index}].unitPrice`,e.target.value)
                 setValue(`category[${mainIndex}].items[${index}].total`,e.target.value * getValues()?.category?.[mainIndex]?.items?.[index]?.operatingHrs)
                }}
              />
              <RHFTextField
                type="number"
                size="small"
                name={`category[${mainIndex}].items[${index}].rentalHrs`}
                label="Rental Hrs"
                placeholder=""
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                type="number"
                size="small"
                name={`category[${mainIndex}].items[${index}].omiReading`}
                label="OM I Reading"
                placeholder=""
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                type="number"
                size="small"
                name={`category[${mainIndex}].items[${index}].omfReading`}
                label="OM F Reading"
                placeholder=""
                InputLabelProps={{ shrink: true }}
              />
              <RHFTextField
                type="number"
                size="small"
                name={`category[${mainIndex}].items[${index}].operatingHrs`}
                label="Operating Hrs"
                placeholder=""
                InputLabelProps={{ shrink: true }}
                onChange={(e)=>{
                 setValue(`category[${mainIndex}].items[${index}].operatingHrs`,e.target.value)
                 setValue(`category[${mainIndex}].items[${index}].total`,e.target.value * getValues()?.category?.[mainIndex]?.items?.[index]?.unitPrice)
                }}
              />
              <RHFSelect
                name={`category[${mainIndex}].items[${index}].availablity`}
                size="small"
                label="Availablity"
                InputLabelProps={{ shrink: true }}
              >
                {availability.map((service) => (
                  <MenuItem key={service.id} value={service.value}>
                    {service.label}
                  </MenuItem>
                ))}
              </RHFSelect>
              <RHFSelect
                name={`category[${mainIndex}].items[${index}].locationType`}
                size="small"
                label="Location Type"
                InputLabelProps={{ shrink: true }}
                onChange={(e)=>{
                  let value=e.target.value
                  setValue(`category[${mainIndex}].items[${index}].locationType`,value)
                  if(value==='job_site'){
                    setIsDisabledLocation(true)
                    setValue(`category[${mainIndex}].items[${index}].location`,completeData?.metadata?.project?.address1)
                  }else if(value==='office_address'){
                    setIsDisabledLocation(true)
                    setValue(`category[${mainIndex}].items[${index}].location`,completeData?.metadata?.company?.complete_address)
                  }else if(value==='other'){
                    setIsDisabledLocation(false)
                    setValue(`category[${mainIndex}].items[${index}].location`,'')
                  }else{
                    setIsDisabledLocation(true)
                    setValue(`category[${mainIndex}].items[${index}].location`,'')
                  }
                }}
              >
                {locationTypes.map((service) => (
                  <MenuItem key={service.id} value={service.value}>
                    {service.label}
                  </MenuItem>
                ))}
              </RHFSelect>

              <RHFTextField
                 disabled={isDisabledLocation}
                size="small"
                name={`category[${mainIndex}].items[${index}].location`}
                label="Location"
                placeholder=""
                InputLabelProps={{ shrink: true }}
              />

<RHFTextField
                disabled
                size="small"
                type="number"
                name={`category[${mainIndex}].items[${index}].total`}
                label="Total"
                placeholder="0.00"
                // value={ values?.category?.[mainIndex]?.items?.[index]?.total 
                //       ? values.category[mainIndex].items[index]?.total?.toFixed(2) 
                //       : ''
                // }
                
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Box sx={{ typography: 'subtitle2', color: 'text.disabled' }}>$</Box>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  // maxWidth: { md: 104 },
                  [`& .${inputBaseClasses.input}`]: {
                    textAlign: { md: 'right' },
                  },
                }}
              />
            </Stack>
            <Box display="flex" gap="30px">
              { mainItem.items.length - 1 == index && (
                <Button
                  size="small"
                  color="primary"
                  startIcon={<Iconify icon="mingcute:add-line" />}
                  onClick={() => handleAdd(mainIndex)}
                  sx={{ flexShrink: 0 }}
                >
                  Add Item
                </Button>
              )}
              <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(mainIndex,index)}
              >
                Remove
              </Button>
            </Box>
          </Stack>
          ))}
       
       
       </>
        ))}
      </Stack>

      <Divider sx={{ my: 3, borderStyle: 'dashed' }} />
    </Box>
  );
}
